import { Subscription } from '@apollo/client/react/components';
import React from 'react';
import { isUsingSystemMatchEvents, MATCH_LIVE_SUBSCRIPTION } from '@amf/shared/data/Match';
import { apolloClient } from '@amf/shared/lib/graphQlClient';
import { MatchDetailItemFragment, MatchEventFragment } from '@amf/shared/types/graphql';
import MatchJumbotronEvent from '@amf/shared/components/match/MatchJumbotronEvent';

type Props = {
  match: MatchDetailItemFragment;
};

function MatchJumbotronEventHandler({ match }: Props) {
  if (!isUsingSystemMatchEvents(match)) return null;
  if (!process.env.NEXT_PUBLIC_GRAPH_QL_WS) return null;
  return (
    <Subscription
      subscription={MATCH_LIVE_SUBSCRIPTION}
      client={apolloClient}
      fetchPolicy='no-cache'
      variables={{
        id: match.id,
        union: process.env.NEXT_PUBLIC_UNION,
      }}
    >
      {({ data, loading }) => {
        const event = data?.liveMatch.event as MatchEventFragment | undefined;
        if (!event || loading) return null;
        return <MatchJumbotronEvent event={event} match={match} />;
      }}
    </Subscription>
  );
}

export default MatchJumbotronEventHandler;
